import styles from './index.module.scss'
import { useEffect, useRef, useState } from 'react'
import light1 from '../../assets/手机.png'
import light2 from '../../assets/扫码.png'
import logo2 from '../../assets/吾道科技@2x.png'
import bg from '../../assets/bg.png'

import accountJpg from '../../assets/footer-official-account.jpg'
import contactJpg from '../../assets/QR-contact.jpg'
import {
  Form,
  Input,
  Button,
  Checkbox,
  Spin,
  message,
  Modal,
  Carousel,
  Popover,
  Space,
} from 'antd'
import { useUnmount, useEventListener } from 'ahooks'
import Api from '../../api/index.js'
import { verificationCodeIntervalTime } from '../../setting.js'
import { setSuperGroup, setToken, getToken } from '../../utils/cookie.js'
import useUrlState from '@ahooksjs/use-url-state'
import { isMcpAuthorizationUrl, readMainSession, mainSessionFromToken, saveMainSession,
  captureMainSession, isMainSessionCurrent, MCP_REQUEST_OPTIONS } from '../../utils/mcpOAuth'
import { getLocationOrigin } from '../../utils/util.js'
import MyButton from '../../components/MyButton'
import WechatPhoneBindModal from '../../components/WechatPhoneBindModal'
import {
  WECHAT_QR_EXPIRED_CODE,
  createQrPoller,
  getApiPayload,
} from '../../utils/wechatQr'

export default function SassLogin() {
  const [type, setType] = useState('登录')
  const [loginQr, setLoginQr] = useState('')
  const [upLoading, setUpLoading] = useState(false)

  const [agreeTerms, setAgreeTerms] = useState(false)
  const [countdownSecond, setCountdownSecond] = useState(0)
  const [countdownSecond2, setCountdownSecond2] = useState(0)

  const [isOverdue, setIsOverdue] = useState(false)
  const [imgLoading, setImgLoading] = useState(false)
  const [bindingPollToken, setBindingPollToken] = useState('')
  const [bindingRedirect, setBindingRedirect] = useState('')

  const [prdList, setPrdList] = useState([])
  const [prdCode, setPrdCode] = useState(null)
  const [prdLogoIndex, setPrdLogoIndex] = useState(0)

  const [isFindOpen, setIsFindOpen] = useState(false)
  const [defaletSelect, setDefaultSelect] = useState(true)
  const [defaultType, setDefaultType] = useState('验证码登录')

  const [form] = Form.useForm()
  const [bindForm] = Form.useForm()

  const [state, setState] = useUrlState({}, { navigateMode: 'replace' })
  const mcpRedirect = isMcpAuthorizationUrl(state.redirect)
  const mcpPrefixRef = useRef()
  const bindingSessionRef = useRef(null)

  const pollerRef = useRef(null)
  const silentPollerRef = useRef(null)
  const silentPollingRef = useRef(false)
  const qrRequestRef = useRef(0)
  useUnmount(() => {
    //如果之前有定时器  清掉
    if (window.SMSCountdownTimer) {
      clearInterval(window.SMSCountdownTimer)
      window.SMSCountdownTimer = null
    }
    if (window.SMSCountdownTimer2) {
      clearInterval(window.SMSCountdownTimer2)
      window.SMSCountdownTimer2 = null
    }
    pollerRef.current?.stop()
    pollerRef.current = null
    silentPollingRef.current = false
    if (silentPollerRef.current) {
      clearTimeout(silentPollerRef.current)
      silentPollerRef.current = null
    }
    qrRequestRef.current += 1
  })

  const stopQrPolling = () => {
    pollerRef.current?.stop()
    pollerRef.current = null
  }

  const setQrExpired = () => {
    stopQrPolling()
    setIsOverdue(true)
    message.error('二维码或登录凭证已过期，请刷新二维码')
  }

  const startQrPolling = (pollToken, expiresIn, productContext) => {
    stopQrPolling()
    const poller = createQrPoller({
      poll: (token) => isMcpAuthorizationUrl(productContext.redirect)
        ? Api.getTokenByPollToken(token, MCP_REQUEST_OPTIONS) : Api.getTokenByPollToken(token),
      isComplete: (data) =>
        Boolean(data?.ticket || data?.token || data?.token_response || data?.status === 'phone_binding_required'),
      onComplete: (data) => {
        if (data?.status === 'phone_binding_required') {
          if (isMcpAuthorizationUrl(productContext.redirect)
              && !isMainSessionCurrent(productContext.mainSnapshot, mcpPrefixRef.current)) return
          bindingSessionRef.current = productContext.mainSnapshot
          setBindingRedirect(productContext.redirect)
          setBindingPollToken(pollToken)
        } else {
          loginFunc(data, productContext.redirect, productContext.mainSnapshot)
        }
      },
      onExpired: setQrExpired,
      onError: (msg, code) => {
        if (code !== WECHAT_QR_EXPIRED_CODE && msg) message.error(msg)
      },
    })
    pollerRef.current = poller
    poller.start(pollToken, expiresIn)
  }

  //停止免登录轮询
  const stopSilentPolling = () => {
    silentPollingRef.current = false
    if (silentPollerRef.current) {
      clearTimeout(silentPollerRef.current)
      silentPollerRef.current = null
    }
  }

  //单次执行免登录判断：命中则跳转，未命中则由调用方决定是否继续轮询
  const runSilentLoginTick = async () => {
    silentPollerRef.current = null
    if (!silentPollingRef.current) return false

    try {
      //若已存在本应用 token，直接跳转 redirect
      if (mcpRedirect && mcpPrefixRef.current === undefined) return false
      if (mcpRedirect ? readMainSession(mcpPrefixRef.current) : getToken()) {
        silentPollingRef.current = false
        const redirectUrl = state.redirect
        window.location.href = redirectUrl
        return true
      }
      //调静默登录接口查询免登录信息
      const snapshot = mcpRedirect ? captureMainSession(mcpPrefixRef.current) : null
      const res = await Api.silentLogin(mcpRedirect ? MCP_REQUEST_OPTIONS : undefined)
      if (!silentPollingRef.current) return false
      if (mcpRedirect && !isMainSessionCurrent(snapshot, mcpPrefixRef.current)) {
        stopSilentPolling()
        message.error('登录状态已变化，请重新打开授权页面确认')
        return false
      }
      if (res?.data?.code === 0 && res?.data?.data?.ticket) {
        silentPollingRef.current = false
        //如果嵌在iframe中 则需要判断是否是跳到自动切换界面
        if(!mcpRedirect && (window !== window.top || window !== window.parent)){
          if(sessionStorage.getItem('target_url') && sessionStorage.getItem('need_switch')){
            window.location.href = getLocationOrigin() + `/link?target=${sessionStorage.getItem('target_url')}` 
            return true
          }else{
            loginFunc({ ticket: res.data.data.ticket }, state.redirect)
            return true
          }
        }else{
          loginFunc({ ticket: res.data.data.ticket }, state.redirect, snapshot)
          return true
        }
      }
    } catch (_) {
      //静默吞掉网络错误，继续下一轮
    }

    //未命中，继续下一轮
    if (silentPollingRef.current) {
      silentPollerRef.current = setTimeout(runSilentLoginTick, 3000)
    }
    return false
  }

  //启动免登录轮询：先立即调一次，命中后停止；未命中则每 3s 继续
  const startSilentPolling = () => {
    if (silentPollingRef.current) return //已在轮询中，避免重复启动
    stopSilentPolling()
    silentPollingRef.current = true
    runSilentLoginTick()
  }

  //刷新二维码
  const refreshRQ = async (
    productContext = { prodCode: prdCode, redirect: state.redirect }
  ) => {
    if (isMcpAuthorizationUrl(productContext.redirect)) {
      productContext = { ...productContext, mainSnapshot: captureMainSession(mcpPrefixRef.current) }
    }
    const requestId = qrRequestRef.current + 1
    qrRequestRef.current = requestId
    stopQrPolling()
    setBindingPollToken('')
    setLoginQr('')
    setIsOverdue(false)
    setImgLoading(true)
    try {
      const res = await (isMcpAuthorizationUrl(productContext.redirect)
        ? Api.getQRCodeUrl('2', productContext.prodCode, MCP_REQUEST_OPTIONS)
        : Api.getQRCodeUrl('2', productContext.prodCode))
      if (requestId !== qrRequestRef.current) return
      if (res.data.code === 0) {
        const data = getApiPayload(res)
        setLoginQr(data?.qrcode || '')
        startQrPolling(data?.poll_token, data?.expires_in, productContext)
      } else {
        setIsOverdue(true)
        message.error(res.data.msg)
      }
    } catch (_) {
      if (requestId === qrRequestRef.current) {
        setIsOverdue(true)
        message.error('二维码加载失败，请稍后重试')
      }
    } finally {
      if (requestId === qrRequestRef.current) setImgLoading(false)
    }
  }

  //获取产品图片列表
  const getPicListFunc = () => {
    return Api.getPrdCover(mcpRedirect ? MCP_REQUEST_OPTIONS : undefined).then((res) => {
      return res?.data?.data
    })
  }

  //根据域名获取产品编码
  const getPrdCodeFunc = (link) => {
    return Api.getPrdCode(link).then((res) => {
      return res?.data?.data
    })
  }

  //获取对于产品的配置
  const getPrdConfig = (prd_code) => {
    return Api.getPrdConfig(prd_code, mcpRedirect ? MCP_REQUEST_OPTIONS : undefined).then((res) => {
      if(res?.data?.code === 0){
        if (mcpRedirect) mcpPrefixRef.current = res.data?.data?.prefix
        else localStorage.setItem('prefix', res.data?.data?.prefix || '')
      }
      //拿到产品配置信息后立即发起一次免登录判断（命中即停，未命中再 3s 轮询）
      startSilentPolling()
    });
  }

  useEffect(() => {
    //判断是否点过发送短信
    setSMSCountdownTimer(new Date().getTime())
    // getPicListFunc();
    // if(state.redirect){
    //   getPrdCodeFunc(state.redirect)
    // }
    Promise.all([getPicListFunc(), mcpRedirect ? Promise.resolve({ prd_code: 'SYS' }) : getPrdCodeFunc(state.redirect || '')]).then(
      async (res) => {
        let [prd_list, prd_code_obj] = res
        let flag = !state.redirect || !prd_code_obj.prd_code
        let productRedirect = state.redirect

        let isLocal = !mcpRedirect && (
          state.redirect?.includes('localhost') ||
          state.redirect?.includes('127.0.0.1') ||
          state.redirect?.includes('192.168'))
        if (isLocal) {
          flag = false
          prd_list.push({
            home_url: '',
            is_hide: true,
            prd_code: 'LOCALHOST_PROD',
            cover: [
              {
                bg: bg,
                logo: logo2,
              },
            ],
          })
          prd_code_obj.prd_code = 'LOCALHOST_PROD'
        }
        if (flag) {
          let product = prd_list?.at(0)
          setState({
            ...state,
            redirect: product?.home_url,
            prodCode: product?.prd_code,
          })
          prd_code_obj.prd_code = prd_list?.at(0)?.prd_code
        }
        const prdInfo = prd_list?.find(
          (_) => _.prd_code === prd_code_obj.prd_code
        )
        if (prdInfo?.prd_name) {
          document.title = prdInfo.prd_name + '-登录'
        } else {
          document.title = '吾道科技-登录'
        }
        setPrdList(prd_list)
        // MCP 二维码捕获会话前先确定 Main prefix；普通产品初始化保持原流程。
        if (mcpRedirect) await getPrdConfig(prd_code_obj.prd_code)
        setPrdCode(prd_code_obj?.prd_code)
        refreshRQ({
          prodCode: prd_code_obj?.prd_code,
          redirect: productRedirect,
        })
      }
    )
  }, [])

  useEffect(() => {
    if(prdCode && !mcpRedirect){
      getPrdConfig(prdCode)
    }
  }, [prdCode])

  //用户绑定企业
  const bindEnterprise = (enterpriseName, token) => {
    Api.bindEnterprise(enterpriseName, token).then((res) => {
      if (res.data.code === 0) {
        Api.switchEnterprise(res.data.data?.company_id, null, token).then(
          (res2) => {
            if (res2.data.code === 0) {
              loginFunc(res2.data.data)
            } else {
              message.error(res.data.msg)
              setUpLoading(false)
            }
          }
        )
      } else {
        message.error(res.data.msg)
        setUpLoading(false)
      }
    })
  }

  //提交
  const onFinish = () => {
    if (mcpRedirect && typeof mcpPrefixRef.current !== 'string') {
      message.error('Main 登录配置尚未就绪，请稍后重试')
      return
    }
    if (upLoading) {
      return
    }
    form.validateFields().then((res) => {
      const { enterpriseName, phoneNumber, verificationCode, password } = res
      setUpLoading(true)
      if (type === '登录') {
        let params = {}
        params.phone = phoneNumber
        if (defaultType === '验证码登录') {
          params.verify_code = verificationCode
        } else {
          params.password = password
        }
        /* loginFunc */
        const snapshot = mcpRedirect ? captureMainSession(mcpPrefixRef.current) : null
        Api.loginFunc(params, state.redirect, mcpRedirect ? MCP_REQUEST_OPTIONS : undefined).then((res) => {
          if (mcpRedirect && !isMainSessionCurrent(snapshot, mcpPrefixRef.current)) {
            message.error('登录状态已变化，本次登录已停止，请重新确认')
            setUpLoading(false)
            return
          }
          if (res.data.code === 0) {
            loginFunc(res.data.data, state.redirect, snapshot)
          } else {
            message.error(res.data.msg)
            setUpLoading(false)
          }
        })
      } else if (type === '注册') {
        Api.userLogon({
          phone: phoneNumber,
          verify_code: verificationCode,
        }).then((res2) => {
          if (res2.data.code === 0) {
            const token = res2.data.data.token
            bindEnterprise(enterpriseName, token)
          } else {
            message.error(res2.data.msg)
            setUpLoading(false)
          }
        })
      }
    })
  }

  //登录跳转
  const loginFunc = (data, productRedirect = state.redirect, snapshot) => {
    if (isMcpAuthorizationUrl(productRedirect) && !isMainSessionCurrent(snapshot, mcpPrefixRef.current)) {
      message.error('登录状态已变化，本次登录已停止，请重新确认')
      setUpLoading(false)
      return
    }
    let href = getLocationOrigin() + '/loading'
    const tokenResponse = data?.token_response || data
    if (tokenResponse?.token) {
      if (isMcpAuthorizationUrl(productRedirect)) {
        const session = mainSessionFromToken(tokenResponse.token)
        if (!session || typeof mcpPrefixRef.current !== 'string') {
          message.error('未取得 Main 登录配置或凭据，请重新登录')
          setUpLoading(false)
          return
        }
        if (!saveMainSession(session, mcpPrefixRef.current, snapshot)) return
      } else setToken(tokenResponse.token)
      setSuperGroup(tokenResponse.super_group || false)
    } else if (data?.ticket) {
      href = href + '?ticket=' + encodeURIComponent(data.ticket)
    }
    // if(prdCode){
    //   href = href + (data.ticket ? "&" : "?") + "prdCode=" + prdCode
    // }
    if (productRedirect) {
      //果冻绘写插件端 特殊处理
      // if(['tpl','word','wps']?.some(_=>redirect?.includes(_)) && prdCode === 'AIW_PROD'){
      //   href = redirect + '?ticket=' + data.ticket;
      //   window.location.href = decodeURIComponent(href);
      //   return
      // }
      href =
        href +
        (data?.ticket ? '&' : '?') +
        'redirect=' +
        encodeURIComponent(productRedirect)
    }
    window.location.href = href

    // if (location?.state?.form) {
    //   history.push(location?.state?.form)
    //   return
    // }
    // //登录的话跳转
    // let redirect = '/loginHtml'
    // let url = window.location.href
    // if (/redirect=([^#/?]+)/.test(url)) {
    //   redirect = /redirect=([^#/?]+)/.exec(url)[1]
    //   //开发
    //   if (redirect?.includes('localhost')) {
    //     redirect = redirect + `?token=${data?.token}`
    //   }
    // }
    // window.location.href = decodeURIComponent(redirect)
  }

  //登录/注册切换
  const changeType = () => {
    form.resetFields(['enterpriseName', 'phoneNumber', 'verificationCode'])
    setAgreeTerms(false)
    const _type = type === '登录' ? '注册' : '登录'
    // getQrFunc(_type);
    setType(_type)
  }

  //验证码定时器
  const setSMSCountdownTimer = (time) => {
    const interval = verificationCodeIntervalTime
    //如果之前有定时器  清掉
    if (window.SMSCountdownTimer) {
      clearTimeout(window.SMSCountdownTimer)
      window.SMSCountdownTimer = null
    }
    //就时间缓冲
    const oldSMSCountdownSecond =
      window.localStorage.getItem('SMSCountdownSecond')
    //存入新的时间 缓存
    const diff = time - oldSMSCountdownSecond
    //如果超过60s
    if (diff > interval * 1000) {
      return
    } else {
      //未超过60s
      let intervalTime = interval * 1000 - diff
      intervalTime = parseInt(intervalTime / 1000)
      if (intervalTime <= 0) {
        intervalTime = 0
      }
      //修改
      if (setCountdownSecond) {
        setCountdownSecond(intervalTime)
      }
      //设置定时器
      setTimeout(() => {
        setSMSCountdownTimer(new Date().getTime())
      }, 1000)
    }
  }

  //发送短信
  const sendingSMS = () => {
    form.validateFields(['phoneNumber']).then((res) => {
      const { phoneNumber } = res
      //todo 调取发送验证码的接口
      Api.getVerifyCode({
        phone: phoneNumber,
        type: type === '注册' ? 1 : 2,
      }).then((res) => {
        if (res.data?.code === 0) {
          window.localStorage.setItem(
            'SMSCountdownSecond',
            new Date().getTime()
          )
          setSMSCountdownTimer(new Date().getTime())
        } else {
          message.error(res.data.msg)
        }
      })
    })
  }

  //验证码定时器
  const setSMSCountdownTimer2 = (time) => {
    const interval = verificationCodeIntervalTime
    //如果之前有定时器  清掉
    if (window.SMSCountdownTimer2) {
      clearTimeout(window.SMSCountdownTimer2)
      window.SMSCountdownTimer2 = null
    }
    //就时间缓冲
    const oldSMSCountdownSecond = window.localStorage.getItem(
      'SMSCountdownSecond2'
    )
    //存入新的时间 缓存
    const diff = time - oldSMSCountdownSecond
    //如果超过60s
    if (diff > interval * 1000) {
      return
    } else {
      //未超过60s
      let intervalTime = interval * 1000 - diff
      intervalTime = parseInt(intervalTime / 1000)
      if (intervalTime <= 0) {
        intervalTime = 0
      }
      //修改
      if (setCountdownSecond2) {
        setCountdownSecond2(intervalTime)
      }
      //设置定时器
      setTimeout(() => {
        setSMSCountdownTimer2(new Date().getTime())
      }, 1000)
    }
  }

  //发送短信
  const sendingSMS2 = () => {
    bindForm.validateFields(['phoneNumber']).then((res) => {
      const { phoneNumber } = res
      //todo 调取发送验证码的接口
      Api.getVerifyCode({
        phone: phoneNumber,
        type: 'retrieve_password',
      }).then((res) => {
        if (res.data?.code === 0) {
          window.localStorage.setItem(
            'SMSCountdownSecond2',
            new Date().getTime()
          )
          setSMSCountdownTimer2(new Date().getTime())
        } else {
          message.error(res.data.msg)
        }
      })
    })
  }

  const onFindFinish = () => {
    bindForm.validateFields().then((res) => {
      const { phoneNumber, verificationCode, password } = res
      Api.findPassword({
        phone: phoneNumber,
        verify_code: verificationCode,
        new_password: password,
      }).then((res) => {
        if (res.data.code === 0) {
          message.success(res.data.msg)
        } else {
          message.error(res.data.msg)
        }
        setIsFindOpen(false)
      })
    })
  }

  useEventListener('keydown', (ev) => {
    if (ev.code === 'Enter') {
      onFinish()
    }
  })

  const changeLoginType = (text) => {
    form.resetFields()
    setDefaultType(text)
    if (text === defaultType) {
      return
    } else if (text === '验证码登录') {
      setDefaultSelect(true)
    } else {
      setDefaultSelect(false)
    }
  }

  return (
    <div className={styles.root}>
      <div className="loginPageHeader">
        <img className="loginPageLogo" src={logo2} alt="" />
        <span></span>
        登录
      </div>

      <Carousel
        effect="fade"
        autoplay={true}
        dots={false}
        className="loginPageCarousel"
        afterChange={(a) => {
          if (a === prdLogoIndex) {
            return
          }
          setPrdLogoIndex(a)
        }}
      >
        {(prdList?.find((_) => _.prd_code === prdCode) || {})?.cover?.map(
          (item) => {
            return (
              <div className="loginPageCarouselItem">
                <div
                  className="loginPageCarouselItemBg"
                  style={{ backgroundImage: `url(${item.bg})` }}
                ></div>
                {/* <img src={pic} alt="" /> */}
              </div>
            )
          }
        )}
      </Carousel>
      <div className="contentBoxContent">
        <div className="contentLogoBox">
          <img
            src={
              (prdList?.find((_) => _.prd_code === prdCode) || {})?.cover?.find(
                (__, index) => index === prdLogoIndex
              )?.logo
            }
            alt=""
            srcset=""
          />
        </div>
        <div className="contentBox">
          <div className="contentLeftBox">
            <div className="topTitleBox">
              <img src={light2} alt="" className="lightImg" />
              扫码登录/注册
            </div>
            <div className="lineBox">
              <div className="line"></div>
            </div>
            <div className="qrBox">
              {isOverdue && (
                <div className="overdueBox" onClick={() => refreshRQ()}>
                  <svg
                    t="1701152961032"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    p-id="5490"
                    width="34"
                    height="34"
                  >
                    <path
                      d="M512 919.552c-224.768 0-407.552-182.784-407.552-407.552 0-8.704 0.512-17.408 1.024-26.112l71.68 4.608c-0.512 7.168-0.512 14.336-0.512 21.504 0 185.344 150.528 335.872 335.872 335.872 86.528 0 168.448-32.768 230.912-92.16l49.152 52.224C716.288 880.128 616.96 919.552 512 919.552zM919.552 512h-71.68c0-11.776-0.512-23.552-2.048-35.328-17.92-171.52-161.28-300.544-334.336-300.544-67.584 0-132.096 19.968-187.904 57.344L284.16 174.08c67.072-45.568 145.92-69.632 227.84-69.632 209.408 0 384 156.672 405.504 365.056 1.536 13.824 2.048 28.16 2.048 42.496z"
                      p-id="5491"
                    ></path>
                    <path
                      d="M140.288 290.816L28.16 491.52c-3.072 5.12 1.024 11.776 6.656 11.776H258.56c6.144 0 9.728-6.144 6.656-11.776L153.6 290.816c-3.072-5.632-10.752-5.632-13.312 0zM870.4 675.84L758.272 475.136c-3.072-5.12 1.024-11.776 6.656-11.776h223.744c6.144 0 9.728 6.144 6.656 11.776L883.712 675.84c-2.56 5.12-10.24 5.12-13.312 0zM270.336 202.24a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0zM728.576 784.896a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0z"
                      p-id="5492"
                    ></path>
                  </svg>
                </div>
              )}
              {imgLoading ? (
                <div className="imgLoadingBox">
                  <Spin size="large"></Spin>
                </div>
              ) : loginQr ? (
                <img
                  src={loginQr}
                  alt="请扫描二维码"
                />
              ) : null}
            </div>
            <div className="qrTip">
              {!isOverdue ? `请使用手机微信扫码` : '二维码已失效，点击刷新'}
            </div>
          </div>
          <div className="contentRightBox">
            <div
              className="loginTypeBox"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                changeLoginType('验证码登录')
              }}
            >
              <div className={!defaletSelect ? 'codeLogin' : ''}>
                <div className="topTitleBox">
                  {defaletSelect && (
                    <img src={light1} alt="" className="lightImg" />
                  )}
                  验证码登录
                </div>
                <div className="lineBox">
                  {defaletSelect ? (
                    <div className="line"></div>
                  ) : (
                    <div className="noLine"></div>
                  )}
                </div>
              </div>
              <div className={defaletSelect ? 'passwordLogin' : ''}>
                <div
                  className="topTitleBox"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    changeLoginType('密码登录')
                  }}
                >
                  {!defaletSelect && (
                    <img src={light1} alt="" className="lightImg" />
                  )}
                  密码登录
                </div>
                <div className="lineBox">
                  {!defaletSelect ? (
                    <div className="line"></div>
                  ) : (
                    <div className="noLine"></div>
                  )}
                </div>
              </div>
            </div>
            {defaultType === '验证码登录' ? (
              <div className="dicText">未注册手机号登录时将自动创建账号</div>
            ) : (
              <div className="margin"></div>
            )}

            <div className="formBox">
              <Form
                colon={false}
                layout="vertical"
                autoComplete="off"
                form={form}
              >
                {type === '注册' && (
                  <Form.Item
                    label="企业或组织名称"
                    name="enterpriseName"
                    rules={[
                      { required: true, message: '企业或组织名称不能为空' },
                    ]}
                  >
                    <Input
                      style={{ width: '100%' }}
                      placeholder="请输入企业或组织名称"
                    ></Input>
                  </Form.Item>
                )}

                <Form.Item
                  label="手机号"
                  name="phoneNumber"
                  rules={[
                    { required: true, message: '手机号不能为空' },
                    {
                      pattern:
                        /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
                      message: '手机号格式不对',
                    },
                  ]}
                >
                  <Input
                    autoComplete="off"
                    style={{ width: '100%' }}
                    placeholder="请输入手机号"
                    type='tel'
                    autocomplete="tel"
                  ></Input>
                </Form.Item>
                {defaultType === '验证码登录' ? (
                  <Form.Item
                    label="验证码"
                    name="verificationCode"
                    rules={[
                      { required: true, message: '验证码不能为空' },
                      { pattern: /^[0-9]\d{5}$/, message: '验证码格式不对' },
                    ]}
                  >
                    <div style={{ display: 'flex' }}>
                      <Input
                        autoComplete="off"
                        style={{
                          width: 'calc(100% - 84px)',
                          marginRight: '8px',
                        }}
                        placeholder="请输入验证码"
                      ></Input>
                      <Button
                        className="verificationCodeBtn"
                        type="primary"
                        onClick={sendingSMS}
                        disabled={countdownSecond}
                      >
                        {countdownSecond
                          ? countdownSecond + 's后重试'
                          : '获取验证码'}
                      </Button>
                    </div>
                  </Form.Item>
                ) : (
                  <Form.Item
                    autoComplete="off"
                    label="密码"
                    name="password"
                    rules={[{ required: true, message: '密码不能为空' }]}
                  >
                    <Input.Password
                      style={{ width: '100%' }}
                      placeholder="请输入密码"
                    ></Input.Password>
                  </Form.Item>
                )}
              </Form>
              {type === '注册' && (
                <Checkbox
                  value={agreeTerms}
                  onChange={(e) => {
                    setAgreeTerms(e.target.checked)
                  }}
                  className="checkItem"
                >
                  我已阅读并同意<a href="">服务条款、隐私政策</a>
                </Checkbox>
              )}
            </div>
            {defaultType === '密码登录' && (
              <div className="link">
                <div>
                  <a
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      setIsFindOpen(true)
                    }}
                  >
                    忘记密码 {'>'}
                  </a>
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    changeLoginType('验证码登录')
                  }}
                >
                  <a>注册账户 {'>'}</a>
                </div>
              </div>
            )}

            <div className="upBtn" onClick={onFinish}>
              {defaultType === '验证码登录' ? '注册/登录' : '登录'}
            </div>
            <div className="tipBpx">
              登录即视为您已阅读并同意
              <a href="/legal-agreement/wd_tos.html" target="_blank">
                《服务协议》
              </a>
              和
              <a href="/legal-agreement/wd_privacy.html" target="_blank">
                《隐私协议》
              </a>
            </div>
            {/* <div className="formTip">
            {type === '注册' ? '已有账号' : '还没有账号'}，
            <span onClick={changeType}>
              {type === '注册' ? '去登录' : '立即注册'}
              <RightOutlined />
            </span>
          </div> */}
          </div>
        </div>
      </div>

      <div className="loginPageFooter">
        <div className="moreProducts">
          更多产品
          {(
            prdList?.filter((_) => _.prd_code !== prdCode && !_.is_hide) || {}
          )?.map((item, index) => {
            return (
              <div className="moreProductsItem">
                {index === 0 ? null : <span></span>}
                <div
                  onClick={() => {
                    if (prdCode === item.prd_code) {
                      return
                    }
                    document.title = item.prd_name + '-登录'
                    setPrdLogoIndex(0)
                    setPrdCode(item.prd_code)
                    setState({
                      ...state,
                      prodCode: item.prd_code,
                      redirect: item.home_url,
                    })
                    refreshRQ({
                      prodCode: item.prd_code,
                      redirect: item.home_url,
                    })
                    
                  }}
                >
                  {item.prd_name}
                </div>
              </div>
            )
          })}
        </div>
        <div className="copyright">
          Copyright © 2013-2022 iWudao <div>杭州投知信息技术有限公司</div>
          <div>苏ICP备18000491号-3</div>
        </div>
        <div className="contactInformation">
          <span>咨询电话 0571 - 8877 6680</span>
          <span>服务邮箱 service@iwudao.tech</span>
          <span>
            <Popover
              overlayClassName="footerIconPopover"
              content={
                <div className="footerIconPopoverBox">
                  <img src={contactJpg} alt="" />
                </div>
              }
              title={null}
            >
              <a className="footer-media-container footer-wechat">
                <div className="RQ-wrapper"></div>
              </a>
            </Popover>
            <a
              className="footer-media-container footer-zhihu"
              href="https://www.zhihu.com/people/stine-86"
              target="_blank"
            ></a>
            <Popover
              overlayClassName="footerIconPopover"
              content={
                <div className="footerIconPopoverBox">
                  <img src={accountJpg} alt="" />
                </div>
              }
              title={null}
            >
              <a className="footer-media-container footer-official-account">
                <div className="RQ-wrapper"></div>
              </a>
            </Popover>
          </span>
        </div>
      </div>
      <WechatPhoneBindModal
        visible={Boolean(bindingPollToken)}
        pollToken={bindingPollToken}
        requestOptions={isMcpAuthorizationUrl(bindingRedirect) ? MCP_REQUEST_OPTIONS : undefined}
        onSuccess={(ticket) => loginFunc({ ticket }, bindingRedirect, bindingSessionRef.current)}
        onCancel={() => {
          setBindingPollToken('')
          refreshRQ()
        }}
      />
      {/* 找回密码 */}
      <Modal
        title={'找回密码'}
        maskClosable={false}
        destroyOnClose
        visible={isFindOpen}
        centered
        footer={[
          <Space size={[24]} className="model-btn">
            <MyButton
              onClick={() => {
                setIsFindOpen(false)
              }}
            >
              取消
            </MyButton>
            <MyButton type="default" onClick={onFindFinish}>
              重置密码
            </MyButton>
          </Space>,
        ]}
        onCancel={() => {
          bindForm.resetFields()
          setIsFindOpen(false)
        }}
      >
        <Form
          colon={false}
          layout="vertical"
          autoComplete="off"
          form={bindForm}
        >
          <Form.Item
            label="手机号"
            name="phoneNumber"
            rules={[
              { required: true, message: '手机号不能为空' },
              {
                pattern:
                  /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
                message: '手机号格式不对',
              },
            ]}
          >
            <Input style={{ width: '100%' }} placeholder="请输入手机号" type='tel' autocomplete="tel"></Input>
          </Form.Item>
          <Form.Item
            label="验证码"
            name="verificationCode"
            rules={[
              { required: true, message: '验证码不能为空' },
              { pattern: /^[0-9]\d{5}$/, message: '验证码格式不对' },
            ]}
          >
            <div style={{ display: 'flex' }}>
              <Input
                style={{ width: 'calc(100% - 84px)', marginRight: '8px' }}
                placeholder="请输入验证码"
              ></Input>
              <MyButton
                // className="verificationCodeBtn"
                type="default"
                onClick={sendingSMS2}
                disabled={countdownSecond2}
              >
                {countdownSecond2 ? countdownSecond2 + 's后重试' : '获取验证码'}
              </MyButton>
            </div>
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[
              {
                required: true,
                message: '新密码不能为空',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.resolve()
                  }
                  if (value?.length < 8 || value?.length > 16) {
                    return Promise.reject(
                      new Error('8-16位，至少包含数字/字母/字符两种组合')
                    )
                  }
                  let reg =
                    /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/
                  if (!reg.test(value)) {
                    return Promise.reject(
                      new Error('8-16位，至少包含数字/字母/字符两种组合')
                    )
                  }
                  if (value === getFieldValue('old_password')) {
                    return Promise.reject(new Error('新的密码不能和原密码一样'))
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <div style={{ display: 'flex' }}>
              <Input
                style={{ width: '100%' }}
                placeholder="请输入密码"
                autocomplete="new-password"
              ></Input>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
